import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../contexts/LanguageContext';
import { formatNumber } from '../../lib/format';

export function Footer() {
  const { t } = useTranslation();
  const { language } = useLanguage();
  return (
    <footer className="border-t border-border mt-16">
      <div className="max-w-7xl mx-auto px-4 py-6 flex flex-wrap items-center justify-between gap-4 text-sm text-text-muted">
        <span>© {formatNumber(new Date().getFullYear(), language, { useGrouping: false })} {t('footer.brand')}</span>
        <nav className="flex gap-5" aria-label={t('footer.legalNav')}>
          <Link to="/privacy" className="hover:text-text-primary">{t('footer.privacy')}</Link>
          <Link to="/terms" className="hover:text-text-primary">{t('footer.terms')}</Link>
        </nav>
      </div>
    </footer>
  );
}
